import React, { useRef, useEffect, useState } from 'react'
import { Panel } from 'primereact/panel';
import { Calendar } from 'primereact/calendar';
import properties from '../../config/environmentProperties';
import { InputNumber } from 'primereact/inputnumber';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { Util, expenseApi } from '../../services';
import { useFormik } from 'formik';
import { toast } from "react-toastify";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Fieldset } from "primereact/fieldset";
import { Carousel } from 'primereact/carousel';
import { DescLength } from '../../common/util/constants';
import moment from 'moment';


const CreateExpenses = ({ status, userLegalEntity }) => {
    const [approvers, setApprovers] = useState([]);
    const [showROPopup, setShowROPopUp] = useState(false);
    const [expenseCategories, setExpenseCategories] = useState(null);
    const [allClaims, setAllClaims] = useState([]);
    const fileUploadRef = useRef(null);
    const [currentRow, setCurrentRow] = useState({});
    const [type, setType] = useState('draft');
    const [visible, setVisible] = useState(false);
    const [currentCol, setCurrentCol] = useState({});
    const [loading, setLoading] = useState(false);
    const [expenseData, setExpenseData] = useState([]);
    const [expenseDialog, setExpenseDialog] = useState(false);
    const [selectedDraftExpense, setSelectedDraftExpense] = useState([]);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const docPath = properties.currentEnvironment.docPath + 'expense-documents/';
    const [currentRowData, setCurrentRowData] = useState(null);
    const [updatedClaimDoc, setUpdatedClaimDoc] = useState([]);
    const [formSubmit, setFormSubmit] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [currencies, setCurrencies] = useState([]);
    const [selectedUpdateCurrency, setSelectedUpdateCurrency] = useState(null);

    useEffect(() => {
        getExpenseCategories();
        getLegalEntities();
        getAllClaims();
        fetchApprovers();
    }, [])

    const [expenses, setExpenses] = useState([
        { expenseDate: null, approver: null, expenseCategory: null, expenseAmount: '', currency: null, expenseDescription: '', expenseDocument: [] }
    ]);

    const validateExpense = (values, index) => {
        if (formSubmit) {
            let approverDiv = document.getElementById(`approver[${index}]`)
            const errors = {};
            if (!values.expenseDate) errors.expenseDate = "Date is required";
            if (!values.expenseCategory) errors.expenseCategory = "Category is required";
            if (!values.approver && approverDiv !== null) errors.approver = "Approver is required";
            if (!values.currency) errors.currency = "Currency is required";
            if (!values.expenseAmount) errors.expenseAmount = "Amount is required";
            else if (values.expenseAmount > 200000) errors.expenseAmount = "Amount cannot exceed 200000";
            if (!values.expenseDescription) errors.expenseDescription = "Description is required";
            if (!values.expenseDocument.length) errors.expenseDocument = 'Please upload supporting documents';
            return errors;
        }
    };

    const roEmailPopUp = () => {
        return (
            <Dialog visible={showROPopup} onHide={() => setShowROPopUp(false)}>
                <b>Please attach RO approval Mail for Training and Certifications to Claim reimbursement</b>
            </Dialog>
        )
    }

    const formik = useFormik({
        initialValues: {
            userExpenses: [{
                expenseDate: null,
                expenseCategory: null,
                approver: null,
                expenseAmount: '',
                currency: null,
                expenseDescription: '',
                expenseDocument: {}
            }]
        },
        validate: (values) => {
            if (formSubmit) {
                const errors = {};
                values.userExpenses?.forEach((expense, index) => {
                    const expenseErrors = validateExpense(expense, index);
                    if (Object.keys(expenseErrors).length > 0) {
                        errors.userExpenses = errors.userExpenses || [];
                        errors.userExpenses[index] = expenseErrors;
                    }
                });
                return errors;
            }
        },
        onSubmit: (values) => {
            values.userExpenses.map(expense => {
                if (expense.expenseCategory.title === 'Training and Certifications' && expense.expenseDocument.length <= 1) {
                    setShowROPopUp(true)
                } else {
                    createExpense({ userExpenses: [expense] });
                }
            })
            setExpenses([{ expenseDate: null, approver: null, expenseCategory: null, currency: null, expenseAmount: '', expenseDescription: '', expenseDocument: [] }]);
            setFormSubmit(false)
        },
    });

    const addExpense = () => {
        setExpenses([...expenses, { expenseDate: null, approver: null, expenseCategory: null, expenseAmount: '', currency: null, expenseDescription: '', expenseDocument: {} }]);
        const expArr = [
            ...formik.values.userExpenses,
            {
                expenseDate: null,
                expenseCategory: null,
                approver: null,
                expenseAmount: '',
                currency: selectedCurrency,
                expenseDescription: '',
                expenseDocument: {}
            }
        ]
        formik.setFieldValue('userExpenses', expArr);
        setFormSubmit(false);
    };

    const createExpense = (data) => {
        let obj = [];
        let ids = [];

        data.userExpenses.map(expense => {
            ids = [];
            expense.expenseDocument.map(doc => {
                ids.push(doc.id);
            })
            obj.push({
                date: expense.expenseDate,
                categoryId: expense.expenseCategory.id,
                ids: ids,
                currency: expense.currency?.currency,
                amount: expense.expenseAmount,
                description: expense.expenseDescription,
                approverId: expense.approver?.id,
            })
            return obj;
        })
        expenseApi.createExpense(obj).then((resp) => {
            formik.setFieldValue('userExpenses', {
                expenseDate: null,
                expenseCategory: null,
                approver: null,
                expenseAmount: '',
                currency: null,
                expenseDescription: '',
                expenseDocument: {}
            })
            fileUploadRef.current.clear();
            formik.resetForm();
            formik.setFieldValue(`userExpenses[${0}].currency`, selectedCurrency);
            getAllClaims()
        })
    }

    const getExpenseCategories = () => {
        expenseApi.getCategories().then((resp) => {
            const filteredCategories = resp.data.data.filter((category) => category.status === 1);
            setExpenseCategories(filteredCategories)
        })
    }
    const getLegalEntities = () => {
        expenseApi.getAllLegalEntities().then((resp) => {
            setCurrencies(resp?.data?.data);
            var result = resp?.data?.data.filter((obj) => {
                return obj.code === userLegalEntity;
            });
            setSelectedCurrency(result[0]);
            formik.setFieldValue(`userExpenses[${0}].currency`, result[0]);
        })
    }

    const getAllClaims = () => {
        let param = {
            status: status,
        }
        expenseApi.getExpenseClaimByUserId(param).then((resp) => {
            setAllClaims(resp.data.data);
        })
    }

    const fetchApprovers = () => {
        try {
            expenseApi.getApprovers().then((resp) => {
                setApprovers(resp.data.data)
            })
        } catch (error) {
        }
    }

    const wrapDescription = (rowData) => {
        const description = rowData.description;
        return (
            <div title={description}>
                {description.length > DescLength.DESCRIPTION ? `${description.substring(0, DescLength.DESCRIPTION)}....` : description}
            </div>
        );
    };

    const uploadFiles = (e, expenseIndex, claimId) => {
        expenseApi.uploadFiles(e.files).then(resp => {
            if (resp.data.error) {
                toast.error(resp.data.error.data);
                return;
            }
            const uploadedFileUrl = resp.data.data;
            if (claimId) {
                setUpdatedClaimDoc(uploadedFileUrl);
            }
            console.log(uploadedFileUrl, "uploadedFileUrl")
            formik.setFieldValue(`userExpenses[${expenseIndex}].expenseDocument`, uploadedFileUrl);
            const totalDocs = document.querySelectorAll(".p-fileupload-file-badge");
            for (let index = 0; index < totalDocs.length; index++) {
                totalDocs[index].innerHTML = "Uploaded"
            }
            console.log(formik.values.userExpenses[expenseIndex].expenseDocument, "<<<>>>")
        })
    };

    const ExpenseUpdateClaimData = (e) => {
        try {
            if (e.newData.claimAmount > 200000) {
                toast.error("Claim Amount cannot exceed more than 200000");
                return;
            }
            let param = {
                claimId: e.newData.claimId,
                claimAmount: e.newData.claimAmount,
                currency: selectedUpdateCurrency?.currency,
                description: e.newData.description,
                document: updatedClaimDoc
            };
            expenseApi.updateExpenseClaim(param).then((resp) => {
                if (resp) {
                    setExpenseDialog(false);
                    toast.success(resp.data.message);
                    getAllClaims()
                }
            }, (err) => {
                toast.error("There was some error while updating Expense ClaimData...");
            });
        } catch (error) {
            console.error("There was some error while updating Expense ClaimData...", error);
        }
    };

    const fileRemove = (e) => {
        const leftFiles = updatedClaimDoc.filter(item => item.fileName.split('-')[1].split('.')[0] !== e.file.name.split('.')[0])
        setUpdatedClaimDoc(leftFiles)
    }

    const actionBody = (rowData) => {
        return (
            <>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-secondary mr-2" tooltip="Update Expense" tooltipOptions={{ position: "top" }} onClick={(e) => editExpenseData(e, rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger " tooltip="Delete Expense" tooltipOptions={{ position: "top" }} onClick={(e) => deleteExpenseRecord(rowData)} />
            </>
        )
    }

    const downloadAction = (rowData) => {
        return (
            <>
            <Button icon="pi pi-eye" className="p-button p-button-primary p-button-icon-only"  tooltip="View Files" tooltipOptions={{ position: "top" }} onClick={() => { setCurrentRowData(rowData); setVisible(true) }}/>
        </>
        )
    }

    const renderCarouselContent = (rowData) => {
        return (
            <Carousel
                value={rowData?.docs} numVisible={1} numScroll={1} circular
                itemTemplate={yourCarouselItemTemplate}
            />
        );
    };

    const yourCarouselItemTemplate = (doc) => {
        return (
            <>
                <p>{doc.fileName}</p>
                <iframe src={docPath + doc.fileName} title={`Document ${doc.fileName}`} style={{ width: '100%', height: '900px' }} />
            </>
        )
    };

    const carouselPopup = () => {
        return (
            <Dialog header={'Documents'} visible={visible} style={{ width: '1200px', height: '900px' }} onHide={() => setVisible(false)}>
                {renderCarouselContent(currentRowData)}
            </Dialog>
        )
    }

    const editExpenseData = (e, rowData) => {
        setExpenseData([rowData]);
        setCurrentRow(rowData);
        setExpenseDialog(true);
        const setCurrencyData = currencies.find(currency => currency.currency === rowData.currency);
        setSelectedUpdateCurrency(setCurrencyData);
    };

    const deleteExpenseRecord = (rowData) => {
        confirmDialog({
            target: rowData.currentTarget,
            message: 'Are you sure you want to delete this Expense Record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: "p-button-danger",
            acceptLabel: 'No',
            rejectLabel: 'Yes',
            reject: () => {
                try {
                    const param = {
                        claimIds: [rowData.claimId]
                    }
                    expenseApi.deleteMultipleExpenseRecords(param).then(
                        (resp) => {
                            if (resp) {
                                toast.success("Expense Record has been Deleted successfully...");
                                getAllClaims()
                                setExpenseDialog(false);
                            }
                        },
                        (err) => {
                            // Util.handelResponse(err.response);
                        }
                    );
                } catch (error) {
                    // Util.handelResponse(error, 2);
                }
            },
            accept: () => { }
        });
    }

    const handleUpdateCurrencyChange = (e) => {
        setSelectedUpdateCurrency(e.value)
    };

    const updateCurrencyValue = (options) => {
        return (
            <Dropdown
                value={selectedUpdateCurrency} options={currencies} optionLabel="currency" placeholder="Select a Currency" title="currency" className="w-100"
                onChange={(e) => {
                    handleUpdateCurrencyChange(e);
                    formik.setFieldValue(`userExpenses[${options.index}].currency`, e.value);
                }}
            />
        );
    };

    const UpdateNumber = (options) => {
        return (
            <InputNumber value={options.value} mode="currency" currency={selectedUpdateCurrency?.currency} currencyDisplay="code"
                onValueChange={(e) => {
                    options.editorCallback(e.value);
                }}
            />
        );
    };

    const UpdateDocument = (index, options = {}) => {
        const editorCallback = options.editorCallback || (() => { });
        return (
            <FileUpload onRemove={(e) => fileRemove(e)} maxFileSize={2097152} accept=".pdf, .jpg, .jpeg, .png" onSelect={(e) => uploadFiles(e, index, expenseData[0].claimId)} auto multiple
                emptyTemplate={<p className="m-0">Drag and drop files here to upload.</p>} customUpload={true} onChange={(e) => editorCallback(e.value)} />
        );
    };

    const getCharacterCount = (index) => {
        const description = formik.values.userExpenses[index]?.expenseDescription || '';
        return DescLength.MAX_LENGTH - description.length;
    };

    const UpdateDescription = (options) => {
        const remainingCharacters = DescLength.MAX_LENGTH - options.value.length;
        return (
            <>
                <InputTextarea style={{ width: "250px", height: '50px' }} value={options.value} onChange={(e) => options.editorCallback(e.target.value)} rows={7} cols={30} maxLength={DescLength.MAX_LENGTH} />
                <small>{remainingCharacters} characters left</small>
            </>
        );
    };

    const timeSheetActivityDeleteTemplate = (rowData, i, type) => {
        return (
            <React.Fragment>
                <Button type="button" icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => deleteExpenseRecord(rowData, i, type)} />
            </React.Fragment>
        );
    };

    const removeExpenseForm = (index) => {
        // Create a copy of the expenses array
        const updatedExpenses = [...expenses];
        // Remove the expense at the specified index
        updatedExpenses.splice(index, 1);
        // Update the expenses state
        setExpenses(updatedExpenses);
        // Create a copy of the userExpenses array in formik values
        const updatedUserExpenses = [...formik.values.userExpenses];
        // Remove the expense at the specified index
        updatedUserExpenses.splice(index, 1);
        // Update the userExpenses field in formik values
        formik.setFieldValue('userExpenses', updatedUserExpenses);
        setFormSubmit(false)
    }

    const SelectedCheckedExpense = (e) => {
        if (e.value.length > 0) {
            setSaveDisabled(false);
        } else {
            setSaveDisabled(true);
        }
        setSelectedDraftExpense(e.value);
    }

    const createExpenseData = (type, expStatus) => {
        let submitReviewExpense;
        if (type === "draft") {
            submitReviewExpense = selectedDraftExpense?.length > 0 ? selectedDraftExpense : allClaims;
        }
        var claimIds = submitReviewExpense?.map((item) => item.claimId);
        const param = {
            status: expStatus,
            claimId: claimIds,
        };
        try {
            expenseApi.updateDraftExpense(param).then(
                (resp) => {
                    if (resp.data.success === false) {
                        toast.error(resp.data.error);
                        return;
                    }
                    setSaveDisabled(true);
                    toast.success("Expense Record has been Created & Shared for Further Approvals..");
                    getAllClaims();
                    setSelectedDraftExpense([])

                },
                (err) => {
                    toast.error("There was some error while updating Expense Data...");
                }
            );
        } catch (error) {
            toast.error("There was some error while updating Expense Data...");
        }
    };

    const deleteAllExpenseRecords = (type) => {
        confirmDialog({
            message: `Are you sure you want to delete this Expense Record${selectedDraftExpense.length > 1 ? 's' : ''}?`,
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: "p-button-danger",
            acceptLabel: 'No',
            rejectLabel: 'Yes',
            reject: () => {
                let deleteAllExpense;
                if (type === "draft") {
                    deleteAllExpense = selectedDraftExpense.length > 0 ? selectedDraftExpense : allClaims;
                } else {
                    deleteAllExpense = selectedDraftExpense.length > 0 ? selectedDraftExpense : allClaims;
                }
                let pram = []
                deleteAllExpense.map((item) => {
                    pram.push(item.claimId)
                }
                );
                const param = {
                    claimIds: pram,
                };
                try {
                    expenseApi.deleteMultipleExpenseRecords(param).then(
                        (resp) => {
                            if (resp) {
                                toast.success("Expense Record has been deleted successfully...");
                                getAllClaims()
                                setSaveDisabled(true)
                            }
                        },
                        (err) => {
                            // Util.handelResponse(err.response);
                        }
                    );
                } catch (error) {
                    // Util.handelResponse(error, 2);
                }
            },
            accept: () => { }
        });
    }

    const UpdateExpenseRecords = () => {
        return (
            <Dialog className="pop-up-dialog" header={"Edit Expense(" + currentRow?.date + ")"} visible={expenseDialog} onHide={() => setExpenseDialog(false)} >
                <Fieldset>
                    <div style={{ width: "170vh" }}>
                        <DataTable key={"edit"} columnResizeMode="fit" responsiveLayout="scroll" value={expenseData} editMode="row" onRowEditComplete={(e) => ExpenseUpdateClaimData(e, currentCol, type)}>
                            <Column field="date" header="Date" style={{ minWidth: "8rem" }} ></Column>
                            <Column field="claimId" header="ClaimID" style={{ minWidth: "8rem" }} ></Column>
                            <Column field="currency" header="Currency" editor={updateCurrencyValue} style={{ minWidth: "5rem" }} ></Column>
                            <Column field="claimAmount" header="Claim-Amount" editor={UpdateNumber} style={{ minWidth: "10rem" }} ></Column>
                            <Column body={wrapDescription} field="description" header="Description" editor={(options) => UpdateDescription(options)}  ></Column>
                            <Column field="document" header="Document" editor={(options) => UpdateDocument(options)} body={downloadAction} ></Column>
                            <Column rowEditor headerStyle={{ minWidth: "8rem" }} bodyStyle={{ textAlign: "center" }}></Column>
                            <Column field="" header="Action" body={(e) => timeSheetActivityDeleteTemplate(e, currentCol, type)} style={{ minWidth: "3rem" }}></Column>
                        </DataTable>
                    </div>
                </Fieldset>
            </Dialog>
        );
    };

    const categoryChange = (e, index) => {
        formik.setFieldValue(`userExpenses[${index}].expenseCategory`, e.value)
        if (e.value?.type !== 3 && formik?.values?.userExpenses[index].expenseCategory?.type === 'POS') {
            formik.setFieldValue(`userExpenses[${index}].approver`, null)
        }
    }

    const calendarField = (index) => (
        <div>
            <Calendar maxDate={new Date()} className='w-100' id="date" readOnlyInput dateFormat="yy-mm-dd" mask="9999/99/99" showIcon placeholder="Date"
                onChange={(e) => {
                    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    let dateInTimeZone = new Date(e.value.toLocaleString('en-US', { timeZone: timeZone }));
                    const formattedDate = moment(dateInTimeZone).format('YYYY-MM-DD');
                    formik.setFieldValue(`userExpenses[${index}].expenseDate`, formattedDate);
                }}
                name={`userExpenses[${index}].expenseDate`} value={formik.values.userExpenses[index]?.expenseDate ? moment(formik.values.userExpenses[index].expenseDate, 'YYYY-MM-DD').toDate() : null} />
            {formik.errors.userExpenses?.[index]?.expenseDate && (
                <small className="p-error">{formik.errors.userExpenses[index].expenseDate}</small>
            )}
        </div>
    );

    const categoryDropdownField = (index) => (
        <div>
            <Dropdown id='category' options={expenseCategories} optionLabel="title" placeholder="Select a Category" className="w-100"
                value={formik.values.userExpenses[index]?.expenseCategory}
                name={`userExpenses[${index}].expenseCategory`} onChange={(e) => categoryChange(e, index)} />
            {formik.errors.userExpenses?.[index]?.expenseCategory && (
                <small className="p-error">{formik.errors.userExpenses[index].expenseCategory}</small>
            )}
        </div>
    );

    const approverDropdownField = (index) => (
        <div>
            <Dropdown id={`approver[${index}]`} options={approvers} optionLabel="name" placeholder="Select Approver" className="w-100"
                value={formik.values.userExpenses[index]?.approver} name={`userExpenses[${index}].approver`}
                onChange={(e) => formik.setFieldValue(`userExpenses[${index}].approver`, e.value)} />
            {formik.errors.userExpenses?.[index]?.approver && (
                <small className="p-error">{formik.errors.userExpenses[index].approver}</small>
            )}
        </div>
    );

    const currencyChange = (e, index) => {
        formik.setFieldValue(`userExpenses[${index}].currencyInput`, e.value.currency)
        formik.setFieldValue(`userExpenses[${index}].currency`, e.value);
    }

    const currencyDropdownField = (index) => (
        <div>
            <Dropdown id='currencycode' name={`userExpenses[${index}].currency`} value={formik.values.userExpenses[index]?.currency} options={currencies} optionLabel="currency" title="currency" placeholder="Select Currency" className="w-100"
                onChange={(e) => currencyChange(e, index)}
            />
            {formik.errors.userExpenses?.[index]?.currency && (
                <small className="p-error">{formik.errors.userExpenses[index].currency}</small>
            )}
        </div>
    );

    const inputNumberField = (index, fieldName, placeholder) => (
        <div>
            {selectedCurrency && (
                <InputNumber type="float" mode="currency" placeholder={placeholder} className="w-100" currencyDisplay="code"
                    name={`userExpenses[${index}].${fieldName}`} value={formik.values.userExpenses[index]?.[fieldName]}
                    onValueChange={(e) => formik.setFieldValue(`userExpenses[${index}].${fieldName}`, e.value)}
                    currency={formik.values.userExpenses[index]?.currencyInput ? formik.values.userExpenses[index]?.currencyInput : selectedCurrency?.currency}
                />
            )}
            {formik.errors.userExpenses?.[index]?.[fieldName] && (
                <small className="p-error">{formik.errors.userExpenses[index][fieldName]}</small>
            )}
        </div>
    );

    const descriptionFormField = (index, fieldName, placeholder, maxLength) => (
        <div>
            <InputTextarea name={`userExpenses[${index}].${fieldName}`}
                value={formik.values.userExpenses[index]?.[fieldName]}
                onChange={formik.handleChange} placeholder={placeholder} className="w-100" rows={7} maxLength={maxLength} style={{ resize: 'none' }} />
            <span style={{ float: "right" }}>{getCharacterCount(index)} Characters Left</span>
            {formik.errors.userExpenses?.[index]?.[fieldName] && (
                <small className="p-error">{formik.errors.userExpenses[index][fieldName]}</small>
            )}
        </div>
    );

    const fileUploadField = (index) => (
        <div>
            <FileUpload onRemove={(e) => formik.setFieldValue(`userExpenses[${index}].expenseDocument`, formik.values.userExpenses[index].expenseDocument.filter(item => item?.fileName.split('-')[1] !== e?.file?.name))}
                maxFileSize={2097152} ref={fileUploadRef} accept=".pdf, .jpg, .jpeg, .png" onSelect={(e) => uploadFiles(e, index, "")}
                auto name={`userExpenses[${index}].expenseDocument`} multiple
                emptyTemplate={<p className="m-0">Drag and drop files here to upload.</p>} customUpload={true} />
            {formik.errors.userExpenses?.[index]?.expenseDocument && (
                <small className="p-error">{formik.errors.userExpenses[index].expenseDocument}</small>
            )}
        </div>
    );

    return (
        <div className="tabview-demo ess-page expense_page">
            <form onSubmit={formik.handleSubmit} autocomplete="off">
                {expenses.map((x, index) => {
                    return (
                        <div className='ess-border pt-3'>
                            <Button type="button" className='expense-close-btn' icon="pi pi-times" rounded text severity="danger" aria-label="Cancel" onClick={() => removeExpenseForm(index)} />
                            <div className="formgrid grid">
                                <div className="field col-3">
                                    {calendarField(index)}
                                </div>
                                <div className="field col-3">
                                    {categoryDropdownField(index)}
                                </div>
                                {formik.values.userExpenses[index]?.expenseCategory?.type === 2 ? (
                                    <>
                                        <div className="field col-2">
                                            {approverDropdownField(index)}
                                        </div>
                                        <div className="field col-2">
                                            {currencyDropdownField(index)}
                                        </div>
                                        <div className="field col-2">
                                            {inputNumberField(index, 'expenseAmount', 'Amount')}
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="field col-3">
                                            {currencyDropdownField(index)}
                                        </div>
                                        <div className="field col-3">
                                            {inputNumberField(index, 'expenseAmount', 'Amount')}
                                        </div>
                                    </>
                                )}
                                <div className="field col-6">
                                    {descriptionFormField(index, 'expenseDescription', 'Description', DescLength.MAX_LENGTH)}
                                </div>
                                <div className="field col-6 upload-expense">
                                    {fileUploadField(index)}
                                </div>
                            </div>
                        </div>
                    )
                })}
                <div className='ess-border mt-0'>
                    <div className="p-2">
                        <Button label="Save As Draft" aria-label="Save" className='p-button-secondary' type='submit' onClick={() => setFormSubmit(true)} />
                        <Button label="Add Expense" aria-label="Save" className='p-button ml-1' type='button' onClick={addExpense} />
                    </div>
                </div>
            </form>
            <div className='ess-border ess-table mt-1 p-2'>
                <DataTable
                    paginator
                    responsiveLayout="scroll"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    rows={10} rowsPerPageOptions={[10, 20, 50]}
                    Key="id" selectionMode="checkbox" value={allClaims}
                    resizableColumns columnResizeMode="fit"
                    scrollable="horizontal"
                    stripedRows editMode="row"
                    selection={selectedDraftExpense}
                    onSelectionChange={(e) => { SelectedCheckedExpense(e) }}
                >
                    <Column selectionMode="multiple" headerStyle={{ width: "4rem" }} exportable={false} ></Column>
                    <Column field="date" header="Date" style={{ minWidth: '1rem' }} />
                    <Column field="claimId" header="Claim-ID" style={{ minWidth: '1rem' }} />
                    <Column field="claimAmount" header="Claim-Amount" style={{ minWidth: '1rem' }} body={(rowData) => Util.renderClaimAmount(rowData)} />
                    <Column field="ExpenseCategory.title" header="Category" style={{ minWidth: '1rem' }} />
                    <Column body={wrapDescription} field="description" header="Description" style={{ Width: '3rem' }} />
                    <Column field="document" header="Document" style={{ minWidth: '1rem' }} body={downloadAction} />
                    <Column header="Action" style={{ minWidth: '1rem' }} body={actionBody}  />
                </DataTable>
                <div className='mt-2'>
                    <Button label='Delete All' icon="pi pi-trash" className='mr-2' severity='danger' onClick={(e) => deleteAllExpenseRecords("draft")} disabled={saveDisabled} />
                    <Button label="Save & Submit" icon="pi pi-check" loading={loading} onClick={(e) => createExpenseData('draft', 1)} disabled={saveDisabled} />
                </div>
            </div>
            <React.Fragment>
                {carouselPopup()}
                {UpdateExpenseRecords()}
                {roEmailPopUp()}
            </React.Fragment>
        </div>
    )
}
export default CreateExpenses;